import React, { useState } from "react";
import { Logo, cartIcon } from "../assets/images/";
import { SocialMediaNav } from "./";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const SocialMedia = ({ WTBRef }) => {
  return (
    <div className="my-8 flex flex-col justify-end gap-8 sm:flex-row">
      <SocialMediaNav />
      <Link
        className="ml-8 mr-16 flex items-center justify-center gap-2 alx-donde-menu"
        to="/"
      >
        <img src={cartIcon} alt="" className="mr-2 w-10" />
        <p className="text-center text-2xl font-semibold uppercase text-white">
          Where to buy
        </p>
      </Link>
    </div>
  );
};

/*const scrollTo = (e, ref) => {
  e.preventDefault();
  ref.current.scrollIntoView({ behavior: "smooth" });
};*/

const NavegableHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sectionData = [
    { name: "About Us", link: "/" },
    { name: "Products", link: "/" },
    { name: "Recipes", link: "/" },
    { name: "Contact", link: "/" },
    { name: "News", link: "/news" },
  ];
  const navElems = [];
  const navElemStyle = "text-lg lg:text-xl xl:text-2xl text-white uppercase";

  sectionData.map((elem) =>
    navElems.push(
      <Link
        key={elem.name}
        to={elem.link}
        className={navElemStyle}
      >
        {elem.name}
      </Link>
    )
  );

  return (
    <header className="flex flex-col justify-center bg-mf-orange-200 font-gothamBold relative z-50 drop-shadow-[0_10px_35px_rgba(251,119,0,1)]">
      <SocialMedia />
      <nav className="flex justify-between md:justify-center relative alx-menu-gral-0">
        <div className=" hidden px-4 text-center md:flex md:items-center md:gap-8 lg:gap-[6vw]">
          
          <Link to="/" id="alx-logo-isadora">
            <img
                src={Logo}
                alt="Isadora logo"
                className="w-52 lg:w-72 -mb-8 lg:-mb-16"
            />
          </Link>
          {navElems[0]}
          {navElems[1]}
          {navElems[2]}
          {navElems[3]}
          {navElems[4]}
        </div>
        <div
          className={`flex w-full justify-between p-4 md:hidden ${
            isOpen ? "items-start" : ""
          }`}
          id="mobile-menu"
        >
          

          <Link to="/" id="alx-logo-isadora-mobile">
            <img
                src={Logo}
                alt="Isadora logo"
                className="w-52 lg:w-72 -mb-8 lg:-mb-16"
            />
          </Link>




          <div className={`p-2 sm:px-3 ${isOpen ? "flex flex-col" : "hidden"}`}>
            {navElems}
          </div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            aria-controls="mobile-menu"
            aria-expanded="false"
          >
            <span className="sr-only">Abrir menú</span>
            <FontAwesomeIcon
              icon={isOpen ? faXmark : faBars}
              className="text-2xl text-white"
            />
          </button>
        </div>
      </nav>
    </header>
  );
};

export default NavegableHeader;
